import { render, staticRenderFns } from "./TravelGeneral.vue?vue&type=template&id=e84d0e9c&scoped=true&"
import script from "./TravelGeneral.vue?vue&type=script&lang=js&"
export * from "./TravelGeneral.vue?vue&type=script&lang=js&"
import style0 from "./TravelGeneral.vue?vue&type=style&index=0&id=e84d0e9c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e84d0e9c",
  null
  
)

component.options.__file = "TravelGeneral.vue"
export default component.exports